import React from "react";
import { FaTimes } from "react-icons/fa";
import {
  clearCrmLeadCreatedAtFields,
  formatCrmLeadCreatedAtChipLabel,
  shouldHideCrmLeadCreatedAtChipKey,
} from "../../utils/filterUtils";

export { shouldHideCrmLeadCreatedAtChipKey };

const defaultChipStyle = { fontSize: "0.6rem", lineHeight: "0.25rem" };

/**
 * Consolidated CRM Lead Created At chip (preset, between, or after).
 * Use once per page alongside the generic advanced-filter chip map.
 */
export default function CrmLeadCreatedAtFilterChips({
  advancedFilters,
  setAdvancedFilters,
  chipStyle = defaultChipStyle,
}) {
  const label = formatCrmLeadCreatedAtChipLabel(advancedFilters);
  if (!label) return null;

  return (
    <div className="flex items-center bg-indigo-50 p-2 rounded" style={chipStyle}>
      <span className="text-indigo-600">{label}</span>
      <button
        type="button"
        className="ml-2 text-gray-600"
        onClick={() => setAdvancedFilters((prev) => clearCrmLeadCreatedAtFields(prev))}
      >
        <FaTimes />
      </button>
    </div>
  );
}
